import React from 'react';
import Link from 'gatsby-link';
import logo from '../assets/images/logo_blanc_full_small.png';
import Scrollchor from 'react-scrollchor';
import ScrollAnimation from 'react-animate-on-scroll';


const Banner = (props) => (
    <section id="banner" className="major">
		<div className="inner">
        <ScrollAnimation animateIn="stretch">
            <header className="major">
				<h1 className="hide">Sites web, conseil, assistance et sécurité informatique</h1>
				<img src={logo} className="logo" alt="logo societe web2alpes w2a" />
            </header>
		</ScrollAnimation>
		<ScrollAnimation animateIn="fadeInUp">
            <div className="content">
			   	<p>Services, conseil et sécurité informatique</p>
				<p>Pour les professionnels au cœur des Alpes</p>
			</div>
			<div className="content">
				<ul className="actions">
                	<li><Scrollchor to="#services" title="En savoir plus sur les services proposés" className="button next scrolly">En savoir plus</Scrollchor></li>
            	</ul>
            </div>
        </ScrollAnimation>
       	</div>
    </section>
)

export default Banner



// WEBPACK FOOTER //
// ./src/components/Banner.js